import Address from './address';

export default {
    namespaced: true,
    state() {
        return {
            orders: [],
        };
    },
    modules: {
        requester: require('./requester').default,
        sender: new Address('sender'),
        recipient: new Address('recipient'),
        parcel: require('./parcel').default,
        quote: require('./quote').default,
        insurance: require('./insurance').default,
    },
    getters: {
        form(state, getters, rootState, rootGetters) {
            return {
                requester: rootGetters['order/requester/form'],
                sender: rootGetters['order/sender/form'],
                recipient: rootGetters['order/recipient/form'],
                parcel: rootGetters['order/parcel/form'],
                service: rootGetters['order/quote/form'].service,
                insurance: rootGetters['order/insurance/form'],
            }
        },
    },
    actions: {
        loadOrders({commit}) {
            api.order.index().then(
                response => commit('setOrders', response.data.data)
            )
        },
    },
    mutations: {
        setOrders(state, orders) {
            state.orders = orders;
        },
    },
}
